import { NotificationCard } from '../components/Card';
import { Flex, Button, Icon, Box } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import { decode } from 'js-base64';
import { NotificationTime } from '../components/Time';
import { Flow } from '@/assets/icons/nav-v2';

export const ScheduleInterviewNotification = ({ notification = {} }) => {
  const { custom_attributes } = notification;
  const data = JSON?.parse(decode(custom_attributes));
  const { job, content, schedule, candidate } = data;

  return (
    <NotificationCard notification={notification}>
      <Flex gap="14px">
        <Box
          width="34px"
          height="34px"
          bg="pastel-3-light"
          borderRadius="6px"
          p="4px"
        >
          <Icon as={Flow} w="24px" h="24px" color="pastel-3-dark"></Icon>
        </Box>
        <Flex flexDir={'column'}>
          <Flex wrap={'wrap'} alignItems="center" gap={1} mb="12px">
            <KText size="sm-bold" color="secondary-900">
              {candidate?.name}
            </KText>
            <KText>sent you a message about</KText>
            <KText
              size="sm-bold"
              color="primary-600"
              cursor="pointer"
              onClick={() => {
                window.open(job?.url, '_blank');
              }}
              data-test-id="job-link"
            >
              "{job?.name}"
            </KText>
          </Flex>
          <KText
            size="sm-bold"
            color="secondary-700"
            textTransform={'upperCase'}
          >
            message
          </KText>
          <KText size="sm" my="8px">
            {content?.body}
          </KText>
          <NotificationTime notification={notification} />
          <Button
            mt="10px"
            variant="primary"
            width="fit-content"
            onClick={() => {
              window.open(schedule?.url, '_self');
            }}
            data-test-id="view-application-button"
          >
            View Application
          </Button>
        </Flex>
      </Flex>
    </NotificationCard>
  );
};
